<template>
  <div class="componentSty">
    <m-title></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">时间选择</span>
        <el-date-picker
          v-model="year"
          type="month"
          value-format="yyyy-MM"
          placeholder="请选择年份"
        >
        </el-date-picker>
        <div class="cheboxSty">
          <el-radio v-model="radio" label="0">统计车数</el-radio>
          <el-radio v-model="radio" label="1">统计吨数</el-radio>
        </div>
        <button class="buttons" @click="getTableMsg">查询</button>
      </div>
      <div class="componentSty_content_table">
        <div class="tableBox" v-show="tabledata.length">
          <table class="tableSty" cellpadding="0px" cellspacing="0px">
            <tr>
              <th class="thSty">区域</th>
              <th class="thSty">流向</th>
              <th class="thSty">代理</th>
              <th class="thSty" v-for="(item, index) in titleList" :key="item">
                {{ index }}
              </th>
            </tr>
            <tr v-for="(item, index) in tabledata" :key="index">
              <td
                style="
                  bordertop: 1px solid #f3f4f5;
                  borderbottom: 1px solid #f3f4f5;
                "
              >
                {{ item.areaName }}
              </td>
              <td :colspan="allday + 2">
                <table class="tableSty" cellpadding="0px" cellspacing="1px">
                  <tr
                    v-for="(
                      item1, index1
                    ) in item.flowBalanceStatisticsFlowDetailsDtos"
                    :key="index1"
                  >
                    <td style="borderright: 1px solid #f3f4f5">
                      {{ item1.custmername }}
                    </td>
                    <td :colspan="allday + 1">
                      <table
                        class="tableSty"
                        cellpadding="0px"
                        cellspacing="0px"
                      >
                        <tr
                          class="rowSty"
                          v-for="(
                            item2, index2
                          ) in item1.flowBalanceStatisticsFleetDetailsByDayDtos"
                          :key="index2"
                        >
                          <td class="tdSty">{{ item2.fleetNames }}</td>
                          <td :colspan="allday">
                            <table
                              class="tableSty"
                              width="100%"
                              cellpadding="0"
                              cellspacing="0"
                            >
                              <tr>
                                <td
                                  class="tdSty"
                                  v-for="(item3, index3) in titleList"
                                  :key="index3"
                                >
                                  <span v-show="showItem == 0">
                                    {{ item2[item3] || 0 }}
                                  </span>
                                  <span v-show="showItem == 1">{{
                                    item2[item3] / 1000 || 0
                                  }}</span>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
export default {
  data() {
    return {
      listitem: [{ name: "统计分析" }, { name: "区域流向" }],
      titleList: {},
      tabledata: [],
      allday: 0,
      year: "", //年
      radio: "0",
      showItem: "0",
    };
  },
  components: {
    mTitle,
  },
  methods: {
    getMounth(time) {
      let allday = new Date(time[0], time[1], 0).getDate(),
        arr = [
          "one",
          "two",
          "three",
          "four",
          "five",
          "six",
          "seven",
          "eight",
          "nine",
          "ten",
          "eleven",
          "twelve",
          "thirteen",
          "fourteen",
          "fifteen",
          "sixteen",
          "seventeen",
          "eighteen",
          "nineteen",
          "twenty",
          "twentyOne",
          "twentyTwo",
          "twentyThree",
          "twentyFour",
          "twentyFive",
          "twentySix",
          "twentySeven",
          "twentyEight",
          "twentyNine",
          "thirty",
          "thirtyOne",
        ],
        obj = {};
      for (let i = 1; i <= allday; i++) {
        obj[`${time[1]}月${i}日`] = arr[i];
      }
      this.allday = allday;
      this.titleList = obj;
    },
    getTableMsg() {
      antiShake(async (_) => {
        this.showItem = this.radio;
        if (!this.year) return this.$message.info("请选择年份");
        let dt = this.year.split("-");
        this.getMounth(dt);
        let path =
          this.radio === "0"
            ? "/statistics/carsuttlenumber/flowBalanceStatisticsCarCountByMonth" //车数
            : "/statistics/carsuttlenumber/flowBalanceStatisticsTonnageByMonth"; //吨数
        const { data } = await this.$http("api1", path, "get", {
          yearMonth: this.year,
        });
        console.log(data);
        if (data.code != 0) return this.$message.error(data.msg);
        this.tabledata = data.data;
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
<style lang="scss" scoped>
.tableBox {
  width: 160%;
  overflow: auto;
  .tableSty {
    font-size: 80%;
    word-break: break-all;
    table-layout: fixed;
    width: 100%;
    background-color: #f3f4f5;
    .thSty {
      background-color: #ffffff;
      height: 30px;
      border-left: 1px solid #f3f4f5;
    }
    .thSty:first-child {
      border-left: none;
    }
    td {
      text-align: center;
      height: 30px;
      background-color: #fdfdfd;
    }
    .tdSty {
      border-right: 1px solid #f3f4f5;
      border-bottom: 1px solid #f3f4f5;
    }
    .rowSty:last-of-type .tdSty {
      border-bottom: none;
    }
  }
}
</style>


